import React, { useState, useEffect, useRef, Fragment } from "react";
import { connect } from "react-redux";
import {
  TextField,
  Button,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormGroup,
  ThemeProvider,
  Checkbox,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  CircularProgress,
  Container,
  Tooltip,
} from "@material-ui/core";
import { setUserProfile } from "../../../../redux/actions/authActions";
import { Field, reduxForm, getFormValues, change } from "redux-form";
import { ButtonToolbar } from "reactstrap";
import ExpandMoreIcon from "mdi-react/ExpandMoreIcon";
import { withStyles } from "@material-ui/core/styles";
import { Switch, Typography } from  "@material-ui/core";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import SnackBar from "../../../../shared/components/SimpleSnackBar";
import { Link } from "react-router-dom";
import JoditEditor from "jodit-react";
import { matTheme } from "../../../../shared/helpers/utils";
import FileDocumentEditOutlineIcon from "mdi-react/FileDocumentEditOutlineIcon";
import ClearIcon from "mdi-react/TrashCanOutlineIcon";
import UpdateIcon from "mdi-react/ContentSaveEditOutlineIcon";
import renderDropZoneField from "../../../Profile/components/DropZone";
import LinearLoading from "../../../../shared/components/LinearLoading";
import { _capitalizeText } from "../../../../shared/helpers/utils";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import { height } from "@material-ui/system";
import LogoIcon from  "mdi-react/StarBoxOutlineIcon";
import SummaryIcon from  "mdi-react/FileDocumentEditOutlineIcon";
import DetailsIcon from  "mdi-react/FormatListCheckboxIcon";
import ChartIcon from "mdi-react/ChartAreasplineIcon";
const apiUrl = process.env.API_ROOT + "/";

const styles = (theme) => ({
  container: {
    display: "flex",
    gap: "3rem",
    maxWidth: 1000,
    justifyContent:"center",
    padding:0,
    "& .material-form__label.bold": {
      color: "#FFF",
    },
    "& .sub-text": {
      color: "#FFF",
      fontSize: 13,
    },
    "& .MuiTypography-root": {
      color: "#FFF",
    },
    "& .link-text": {
      color: "#FFF",
    },
    "& .logo-container": {
      background: "#FFF",
      padding: 10,
      border: "1px double #FFF",
      borderRadius:8,
      boxShadow:
        "rgba(0, 0, 0, 0.3) 0px 0px 1px -3px, rgba(0, 0, 0, 0.3) 0px 1px 2px 0px, rgba(0, 0, 0, 0.3) 0px 1px 4px 0px",
      outline: "1px solid #eff1f5",
      // backgroundImage:
      //   "linear-gradient(-45deg, #eff1f5 25%, transparent 25%, transparent 50%, #eff1f5 50%, #eff1f5 75%, transparent 75%, transparent)",
      backgroundSize: "30px 30px",
    },
  },
  root: {
    flexDirection: "column",
    alignItems: "left",
    textAlign: "left",
    padding: "20px 20px 10px",
    border: "1px solid #FFF",
    borderRadius: 10,
    background: "rgba(0, 0, 0, 0.07)",
    margin: "20px 0",
  },
  ExpansionPanelSummary: {
    background: "#F5F7FA",
    border: "1px solid #780F9E",
    marginBottom: 5,
  },
  PanelTitle: {
    fontWeight: 600,
    fontSize: 17,
  },
  button: {
    "&.selected": {
      background: "#780F9E",
      color: "#FFF",
    },
    fontSize: 14,
    margin: "0 5px 0 0",
  },
  ".btn-toolbar": {
    justifyContent: "center",
  },
  growElement: {
    // transition: "width 1s ease",
    width: "0%",
    height: "0px",
    overflow: "hidden",
  },
  expanded: {
    height: "auto",
    width: "100%",
    margin: "0px 0",
  },
  switchLabel: {
    display: "flex",
    alignItems: "center",
  },
  onLabel: {
    marginLeft: 8,
    color: "#780F9E",
    fontWeight: "bold",
    marginRight: "10px !important",
    marginTop: "-5px !important",
  },
  offLabel: {
    marginRight: 8,
    color: "#999",
    fontWeight: "bold",
    marginRight: "10px !important",
    marginTop: "-5px !important",
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#780F9E",
      "& + .MuiSwitch-track": {
        backgroundColor: "#780F9E",
      },
    },
  },
  switchTrack: {
    backgroundColor: "#999",
  },
  themeBar: {
    maxWidth: "1000px",
    textAlign: "left",
    margin: "0 auto",
    text: "#FFF",
    "& .material-form__label": {
      color: "#FFF",
    },
    "& .slick-slider .slick-arrow.slick-next": {
      background: "transparent",
      color: "#DBE0E8",
    },
    "& .slick-slider .slick-arrow.slick-prev": {
      background: "transparent",
      color: "#DBE0E8",
    },
  },
});
const detailOptions = {
  "no-details": "No Details",
  "latest-50": "Show Latest Activity - 20 Max",
  "top-50": "Show Top Activity by Price - 20 Max",
};
const WhiteRadio = withStyles({
  root: {
    color: "white",
    "&$checked": {
      color: "white",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
const ExportSettingsForm = (props) => {
  const {
    t,
    user,
    classes,
    setPreview,
    reportParams,
    setParentFetchInProgress,
    formValues,
    setFormValues,
    handleAI,
    aiInProgress,
    aiRun,
    formValuesCheckboxes,
    setFormValuesCheckboxes,
    panel,
    defaultLogo
  } = props;

  const [localFormValues, setLocalFormValues] = useState(formValues);
  const [fetchInProgress, setFetchInProgress] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const editorRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [isBrandLogoAvailable, setIsBrandLogoAvailable] = useState(!user.logo);
  const [snackShow, setSnackShow] = useState({
    show: false,
    message: "",
    type: "",
  });

  const contactFromStorage=localStorage.getItem("contactMarketPulse");


  useEffect(() => {
    setParentFetchInProgress(fetchInProgress);
  }, [fetchInProgress]);

  useEffect(() => {
    setLocalFormValues(formValues);
    if (formValues.aiRefresh) {
      setPreview();
    }
  }, [formValues]);
  const snackOpen = (message, type) => {
    setSnackShow({ show: true, message, type });
  };
  useEffect(() => {
    if (isBrandLogoAvailable) {
      // Trigger the expansion effect after the component is rendered
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [isBrandLogoAvailable]);
  const handleFieldChange = (field, value) => {
    setLocalFormValues((prevState) => ({ ...prevState, [field]: value }));
    setFormValues((prevState) => ({ ...prevState, [field]: value }));
    console.log(`${field}MarketPulse`, value, "formField")
    value &&  localStorage.setItem(`${field}MarketPulse`, value);
    setPreview();
  };
const handleDetailsFieldChange = (field, value) => {
  setLocalFormValues((prevState) => ({ ...prevState, [field]: value }));
  setFormValues((prevState) => ({ ...prevState, [field]: value }));
  setPreview();
};
  const handleLocalFieldChange = (field, value) => {
    setLocalFormValues((prevState) => ({ ...prevState, [field]: value }));
  };

  const handleSave = () => {
    setFormValues(localFormValues);
    setPreview();
  };

  const handleEditorChange = (field, value) => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    handleLocalFieldChange(field, value);
    const newTimeout = setTimeout(() => {
      setFormValues((prevState) => ({ ...prevState, [field]: value }));
      setPreview();
    }, 500);

    setTypingTimeout(newTimeout);
  };

  const clearField = (field) => {
    setLocalFormValues((prevState) => ({ ...prevState, summary: "" }));
    setFormValues((prevState) => ({ ...prevState, summary: "" }));
    setPreview();
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (checked) {
      setFormValuesCheckboxes((prev) => [...prev, name]);
    } else {
      setFormValuesCheckboxes((prev) => prev.filter((item) => item !== name));
    }
  };

  const handleSaveLogo = async (logo) => {
    const oktaToken = process.env.OKTA_TOKEN;
    const apiUrl = process.env.API_ROOT + "/buyerslist/"; //'http://localhost:8000/buyerslist/';
    const { dispatch, user } = props;
    let headers = {
      Authorization: `SSWS ${oktaToken}`,
    };
    const { formLogo } = props;
    let profile = Object.assign({}, user);
    const user_id = profile.id;

    if (logo && logo != "") {
      profile.logo = logo;
    } else {
      profile.logo = "";
    }

    let userData = {
      url: apiUrl + "user/update",
      method: "post",
      query: {
        id: user_id,
        profile: profile,
      },
    };

    _axiosCall(userData)
      .then((res) => {
        console.log("_getUserData res back ,", res);

        if (res && res.profile) {
          let oktaUser = Object.assign({}, res.profile);
          oktaUser["id"] = res.id;
          dispatch(setUserProfile(oktaUser));
          //snackOpen("Your logo has been uploaded to your profile.");
console.log(logo,"myLogoChintan")
          if (logo) {
            setFormValues((prev) => ({ ...prev, branding: "mylogo" }));
            setIsBrandLogoAvailable(false)
            localStorage.setItem(`brandingMarketPulse`, "mylogo");
          } else  {
            setFormValues((prev) => ({ ...prev, branding: "marketproof" }));
          }
        } else {
          if (res.message) {
            snackOpen(
              <Fragment>
                <span>
                  Oops, Your Profile Was Not Updated.{" "}
                  <p
                    className="small-text light-text"
                    style={{ marginLeft: "30px", color: "#FFF" }}
                  >
                    {_capitalizeText(res.message)}
                  </p>
                </span>
              </Fragment>,
              "error"
            );
          } else {
            this.snackOpen(
              "Oops, Something Went Wrong, Your Profile Was Not Updated.",
              "error"
            );
          }
        }
      })
      .catch((error) => {
        console.log("_getUserData error ", error);
        snackOpen(
          "Oops, Something Went Wrong, Your Profile Was Not Updated.",
          "error"
        );
      });
  };
  const snackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackShow({ show: false, message: "" });
  };
  return (
    <>
      {" "}
      <form className="material-form">
      {panel == "branding" ? (
          <Container className={classes.container}>
            <div className={classes.root} style={{ width: 500 }}>
              <div
                style={
                  isExpanded ? { marginBottom: 0 } : { marginBottom: "20px" }
                }
              >
                <div className="mb-2">
                  <span className="material-form__label bold">
                    {user && user.logo ? "Select Logo" : "Add Your Logo"}
                  </span>
                 
                  <hr />
                </div>
              </div>
              <RadioGroup
                aria-label="branding"
                name="branding"
                value={localFormValues.branding}
                onChange={(e) => {
                  handleFieldChange("branding", e.target.value);
                  setIsBrandLogoAvailable(false);
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {user && user.logo && !isExpanded && (
                  <div style={{ width: "100%" }}>
                    <FormControlLabel
                      value="mylogo"
                      control={<WhiteRadio />}
                      label={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div className="logo-container">
                            <img
                              src={user.logo}
                              style={{ width: 160 }}
                              alt="User Logo"
                            />
                          </div>{" "}
                          <span className="ml-3 small-text">
                            <span
                              className="link-text"
                              onClick={() => {
                                setIsBrandLogoAvailable(!isBrandLogoAvailable);
                              }}
                            >
                              (Change Logo)
                            </span>
                          </span>
                        </div>
                      }
                    />
                  </div>
                )}
                <div
                  className={`grow-element theme-light ${classes.growElement} ${
                    isExpanded ? classes.expanded : ""
                  }`}
                >
                  <div className="mb-1">
                    <Typography>
                      {user && !user.logo
                        ? "Upload a PNG or JPG file"
                        : "Change or remove your logo"}
                        <div className="sub-text">
                          {" "}
                          (400px wide by 100px tall for best results)
                        </div>
                    </Typography>
                  </div>
                  <div
                    className="profile-edit__topbar"
                    style={{ maxWidth: 200, alignItems:"center"}}
                  >
                    <Field
                      name="logo"
                      component={renderDropZoneField}
                      //below props are for dropZone Height & loader
                      SnapShotDropZoneHeight={true}
                      SnapShotDropLoader={true}
                      defaultImage={user.logo ? user.logo : null}
                      callback={handleSaveLogo}
                    />
                    {user && user.logo ?
                      <div
                        className="link-text ml-3 small-text"
                        style={{cursor:"pointer"}}
                        onClick={() => {
                          setIsBrandLogoAvailable(!isBrandLogoAvailable);
                        }}
                      >
                        Cancel
                      </div>
                      : null
                    }
                  </div>
                  
                  <hr />
                </div>
               <div style={{ width: "100%" }}>
                 <FormControlLabel
                   value="marketproof"
                   control={<WhiteRadio />}
                   label={
                     <div style={{ display: "flex", alignItems: "center" }}>
                       <div className="logo-container">
                         <img
                           src={defaultLogo}
                           style={{ width: 160 }}
                           alt="Marketproof"
                         />
                       </div>
                       <span className="ml-3 small-text"></span>
                     </div>
                   }
                 />
               </div>
                <div style={{ width: "100%" }}>
                  <FormControlLabel
                    value="hide"
                    control={<WhiteRadio />}
                    label="Do Not Display a Logo"
                  />
                </div>
              </RadioGroup>
            </div>
            <div className={classes.root}>
              <div className="mb-2">
                <span className="material-form__label bold">
                  Choose a Contact Method
                </span>
               
                <hr />
              </div>
              <RadioGroup
                aria-label="contact"
                name="contact"
                value={contactFromStorage || localFormValues.contact || "hide"}
                onChange={(e) => handleFieldChange("contact", e.target.value)}
                onClick={(e) => e.stopPropagation()}
              >
                <div>
                  <FormControlLabel
                    value="hide"
                    control={<WhiteRadio />}
                    label="Hide My Profile"
                  />
                </div>
                <div>
                  <FormControlLabel
                    value="show"
                    control={<WhiteRadio />}
                    label="Show My Profile"
                  />
                </div>
              </RadioGroup>
              <hr />
              <div className="sub-text">
                Update your profile in{" "}
                <Link
                  to={`/my-account`}
                  className="link-text"
                  style={{ textDecoration: "underline" }}
                >
                  My Account
                </Link>
              </div>
            </div>
          </Container>
        ) : null}
         {panel == "details" ? (
          <Container className={classes.container}>
            <div className={classes.root} style={{ width: 500 }}>
              <div
                style={
                  isExpanded ? { marginBottom: 0 } : { marginBottom: "20px" }
                }
              >
                <div className="mb-2">
                <div className="material-form__label bold">
                  Choose Whether to Include Details
                  </div>
                 <div className="small-text light-text" style={{color:"#fff"}}>Select latest or highest priced activity to include on your report</div>
                 
                  <hr />
                </div>
              </div>
              <RadioGroup
                  aria-label="details"
                  name="details"
                  value={localFormValues.details || "no-details"}
                  onChange={(e) => handleDetailsFieldChange("details", e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  row
                >
                  {Object.keys(detailOptions).map((key) => (
                    <div style={{ width: "100%" }}>
                      <FormControlLabel
                        key={key}
                        value={key}
                        control={<WhiteRadio />}
                        label={detailOptions[key]}
                      />
                    </div>
                  ))}
                </RadioGroup>
            </div>
          </Container>
        ) : null}
        {/* <ExpansionPanel
          TransitionProps={{ unmountOnExit: true }}
          id={"contact"}
          defaultExpanded={panel == 'branding'}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls=""
            id={"contact"}
            className={classes.ExpansionPanelSummary}
          >
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          
           
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel
          TransitionProps={{ unmountOnExit: true }}
          id={"title"}
          defaultExpanded={panel == 'summary'}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls=""
            id={"title"}
            className={classes.ExpansionPanelSummary}
          >
            <Container>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: -30,
                }}
              >
                <div>
                  <span className={classes.PanelTitle}>
                   <SummaryIcon />  Edit Title and Summary
                  </span>
                  <div className="small-text light-text">
                    Provide context and background for the reader
                  </div>
                </div>
                
              </div>
            </Container>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ThemeProvider theme={matTheme}>
              <Container>
                <div className={classes.root}>
                  <div style={{ marginLeft: -5, height: 20 }}>
                    {aiRun && aiInProgress && <LinearLoading />}
                  </div>
                  <div className="share__link">
                    <span className="material-form__label bold">Title</span>

                    <TextField
                      value={localFormValues.reportTitle || ""}
                      onChange={(e) =>
                        handleEditorChange("reportTitle", e.target.value)
                      }
                      variant="outlined"
                      className="material-form__field"
                    />
                  </div>

                  <div className="share__link">
                    <hr />
                    <span className="material-form__label bold">Summary</span>
                    <JoditEditor
                      ref={editorRef}
                      value={localFormValues.summary || ""}
                      onBlur={(newContent) => {
                        handleLocalFieldChange("summary", newContent);
                      }}
                      config={{
                        readonly: false,
                        height: 400,
                        allowResizeX: false,
                        enableDragAndDropFileToEditor: false,
                        buttons: [
                          "bold",
                          "italic",
                          "underline",
                          "fontsize",
                          "|",
                          "link",
                          "hr",
                          "align",
                          "|",
                          "undo",
                          "redo",
                        ],
                        buttonsMD: [
                          "bold",
                          "italic",
                          "underline",
                          "fontsize",
                          "|",
                          "link",
                          "hr",
                          "align",
                          "|",
                          "undo",
                          "redo",
                        ],
                        buttonsXS: [
                          "bold",
                          "italic",
                          "underline",
                          "fontsize",
                          "|",
                          "link",
                          "hr",
                          "align",
                          "|",
                          "undo",
                          "redo",
                        ],
                        placeholder: "Report summary",
                        style: { fontSize: 16 },
                      }}
                    />
                  </div>
                </div>
                <ButtonToolbar
                  className="modal__footer mb-3"
                  style={{ justifyContent: "flex-end", marginTop:15 }}
                >
                  <Tooltip title="Use Marketproof AI to generate a title and summary">
                    <Button
                      variant="outlined"
                      color="secondary"
                      className="buyersList__secondary-button"
                      onClick={(e) => {
                        handleAI(e);
                      }}
                      startIcon={
                        <FileDocumentEditOutlineIcon
                          size={16}
                          style={{ marginTop: -2 }}
                        />
                      }
                      style={{ fontSize: 13,marginRight:5 }}
                      disabled={fetchInProgress || aiInProgress}
                    >
                      Rewrite (AI)
                    </Button>
                  </Tooltip>
                  <Tooltip title="Remove summary">
                    <Button
                      variant="outlined"
                      color="secondary"
                      style={{ minWidth: 50, fontSize: 13,marginRight:5 }}
                      className="buyersList__secondary-button"
                      startIcon={
                        <ClearIcon size={16} style={{ marginTop: -2 }} />
                      }
          
                      disabled={fetchInProgress || aiInProgress}
                      onClick={() => clearField()}
                    >
                      Remove
                    </Button>
                  </Tooltip>
                  <Tooltip title="Update summary and title">
                    <Button
                      variant="outlined"
                      color="secondary"
                      className="buyersList__secondary-button"
                      disabled={fetchInProgress || aiInProgress}
                      onClick={handleSave}
                      startIcon={
                        <UpdateIcon size={16} style={{ marginTop: -2 }} />
                      }
                      style={{ fontSize: 13 }}
                    >
                      Save Changes
                    </Button>
                  </Tooltip>
                </ButtonToolbar>
              </Container>
            </ThemeProvider>
          </ExpansionPanelDetails>
        </ExpansionPanel> */}
        {/* <ExpansionPanel
          TransitionProps={{ unmountOnExit: true }}
          id={"chart"}
          defaultExpanded={panel == 'chart'}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls=""
            id={"chart"}
            className={classes.ExpansionPanelSummary}
          >
            <Container>
              <span className={classes.PanelTitle}>
             <ChartIcon/>   Include Trend Charts {" "}
                <span className="small-text">
                  
                </span>
              </span>
              <div className="small-text light-text">
                Choose whether to include trend charts
              </div>
            </Container>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Container>
              <div className={classes.root}>
                <div style={{ width: "100%" }}>
                  <FormGroup>
                 
                    <div className={classes.switchLabel}>
                      {formValuesCheckboxes.includes("showSnapshotMap") ?
                        <Typography className={classes.onLabel}>On</Typography>
                        :
                        <Typography className={classes.offLabel}>Off</Typography>
                      }
                      <FormControlLabel
                        required
                        control={
                          <Switch
                            classes={{
                              switchBase: classes.switchBase,
                              track: classes.switchTrack,
                            }}
                          />
                        }
                        label={"Include a Map on Your Report"}
                        name="showSnapshotMap"
                        checked={formValuesCheckboxes.includes(
                          "showSnapshotMap"
                        )}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                    <div  className="mb-2">
                      <hr/>
                      <span className="material-form__label bold">Choose Whether to Include Charts</span>
                      <div className="small-text light-text">
                        Add or remove trend charts to your report
                      </div>
                    </div>
                    <div className={classes.switchLabel}>
                      {formValuesCheckboxes.includes("showSnapshotBuildingCharts") ?
                        <Typography className={classes.onLabel}>On</Typography>
                        :
                        <Typography className={classes.offLabel}>Off</Typography>
                      }
                      <FormControlLabel
                        required
                        control={
                          <Switch
                            classes={{
                              switchBase: classes.switchBase,
                              track: classes.switchTrack,
                            }}
                          />
                        }
                        label={"Include Trend Charts on Your Report"}
                        name="showSnapshotBuildingCharts"
                        checked={formValuesCheckboxes.includes(
                          "showSnapshotBuildingCharts"
                        )}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                  </FormGroup>
                </div>
              </div>
            </Container>
          </ExpansionPanelDetails>
        </ExpansionPanel>  */}
        {/* <ExpansionPanel
          TransitionProps={{ unmountOnExit: true }}
          id={"details"}
          defaultExpanded={panel == 'details'}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls=""
            id={"details"}
            className={classes.ExpansionPanelSummary}
          >
            <Container>
              <span className={classes.PanelTitle}>
                <DetailsIcon /> Choose Snapshot Details{" "}
               
              </span>
              <div className="small-text light-text">
                Choose how to display additional information
              </div>
            </Container>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Container>
              <div  className="mb-2">
                <hr/>
                <span className="material-form__label bold">Choose Whether to Include Details</span>
                <div className="small-text light-text">
                  Select latest or highest priced activity to include on your report
                </div>
              </div>
              <div className={classes.root}>
                <RadioGroup
                  aria-label="details"
                  name="details"
                  value={localFormValues.details || "no-details"}
                  onChange={(e) => handleFieldChange("details", e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  row
                >
                  {Object.keys(detailOptions).map((key) => (
                    <div style={{ width: "100%" }}>
                      <FormControlLabel
                        key={key}
                        value={key}
                        control={<Radio />}
                        label={detailOptions[key]}
                      />
                    </div>
                  ))}
                </RadioGroup>
              </div>
              
            </Container>
          </ExpansionPanelDetails>
        </ExpansionPanel> */}
         
        
        {/* <ExpansionPanel
          TransitionProps={{ unmountOnExit: true }}
          id={"contact"}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls=""
            id={"contact"}
          >
            <Container>
              <span className="material-form__label bold">
                Choose a Contact Method{" "}
                <span className="small-text">(Optional)</span>
              </span>
              <div className="small-text light-text">
                Display your contact information (Update under{" "}
                <Link to={`/my-account`} className="link-text">
                  My Account
                </Link>
                )
              </div>
            </Container>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Container>
              <div className={classes.root}>
                <RadioGroup
                  aria-label="contact"
                  name="contact"
                  value={localFormValues.contact || "hide"}
                  onChange={(e) => handleFieldChange("contact", e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  row
                >
                  <FormControlLabel
                    value="hide"
                    control={<Radio />}
                    label="Hide My Contact Info"
                  />
                  <FormControlLabel
                    value="show"
                    control={<Radio />}
                    label="Show My Contact Info"
                  />
                </RadioGroup>
              </div>
            </Container>
          </ExpansionPanelDetails>
        </ExpansionPanel> */}
        <hr />
      </form>
      <SnackBar
        snackShow={snackShow.show}
        snackMessage={snackShow.message}
        snackClose={snackClose}
        snackDuration={5000}
        snackType={snackShow.type}
      />
    </>
  );
};

ExportSettingsForm.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.object,
  classes: PropTypes.object.isRequired,
  setPreview: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  console.log(state, "hellostate");
  return {
    formLogo: getFormValues("snapshot-logo")(state),

    // formValues: getFormValues("exportSettings")(state),
    user: state.user,
  };
};

const formWrapped = reduxForm({
  form: "snapshot-logo", // a unique identifier for this form
})(ExportSettingsForm);

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(formWrapped)
);
